module.exports = __webpack_public_path__ + "static/media/custom-ex-1.bc656e3c.jpg";